'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$Closed$() {
}
export { $c_Lpresto_AgentView$Closed$ as $c_Lpresto_AgentView$Closed$ };
$p = $c_Lpresto_AgentView$Closed$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$Closed$;
/** @constructor */
function $h_Lpresto_AgentView$Closed$() {
}
export { $h_Lpresto_AgentView$Closed$ as $h_Lpresto_AgentView$Closed$ };
$h_Lpresto_AgentView$Closed$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 2021313932;
});
$p.l = (function() {
  return "Closed";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "Closed";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.pv = (function() {
  return "";
});
var $d_Lpresto_AgentView$Closed$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$Closed$, "presto.AgentView$Closed$", ({
  Ek: 1,
  b5: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_AgentView$Closed$ as $d_Lpresto_AgentView$Closed$ };
var $n_Lpresto_AgentView$Closed$;
function $m_Lpresto_AgentView$Closed$() {
  if ((!$n_Lpresto_AgentView$Closed$)) {
    $n_Lpresto_AgentView$Closed$ = new $c_Lpresto_AgentView$Closed$();
  }
  return $n_Lpresto_AgentView$Closed$;
}
export { $m_Lpresto_AgentView$Closed$ as $m_Lpresto_AgentView$Closed$ };
//# sourceMappingURL=presto.-Agent-View$-Closed$.js.map
